import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-white text-lg font-semibold mb-3">DrivingTest UK</h3>
            <p className="text-sm text-gray-400">
              Practice for your UK driving theory test with realistic mock exams. Prepare with
              confidence and pass first time.
            </p>
          </div>
          <div>
            <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-3">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/exams" className="hover:text-white transition-colors">
                  Mock Exams
                </Link>
              </li>
              <li>
                <Link to="/categories" className="hover:text-white transition-colors">
                  Categories
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-white transition-colors">
                  Create Account
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-3">
              About the Test
            </h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>50 multiple choice questions</li>
              <li>57 minutes time limit</li>
              <li>43 out of 50 to pass</li>
              <li>Based on DVSA question bank</li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-700 pt-6 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} DrivingTest UK. All rights reserved.</p>
          <p className="mt-1">
            This is a practice platform. Not affiliated with DVSA.
          </p>
        </div>
      </div>
    </footer>
  );
}
